module.exports = __webpack_public_path__ + "img/platform1.97dfe469.png";